import * as React from 'react';

import OrdersTableItem from '../OrdersTableItem';

import OrderLineModel from 'src/model/orderline.model';
import PartReturnModel from 'src/model/partReturn.model';

import './OrdersTableSectionExpandable.scss';
import { IOrders } from 'src/model/modules/orders.model';
import { string } from 'prop-types';
import Loader from 'src/components/common/Loader';

interface IOrdersTableSectionExpandableProps {
  order: IOrders;
  invoices: { [key: string]: OrderLineModel[] };
  handleModalClicked: (
    invoices: { [key: string]: OrderLineModel[] },
    status: string,
    poNumber: string,
    date: string,
    part: PartReturnModel
  ) => void;
  getInvoicePreview: (invoiceNumber: string, orderNumber: string) => void;
  loaderStatus: boolean;
}

class OrdersTableSectionExpandable extends React.Component<
  IOrdersTableSectionExpandableProps,
  any
> {
  public render() {
    return (
      <div className="rp-orders-table-section-expandable">
        {Object.keys(this.props.invoices).map((inv, idx) => {
          return (
            <OrdersTableItem
              key={idx}
              invoiceId={inv}
              invoice={this.props.invoices[inv]}
              order={this.props.order}
              handleModalClicked={this.props.handleModalClicked}
              getInvoicePreview={this.props.getInvoicePreview}
              loaderStatus={this.props.loaderStatus}
            />
          );
        })}
      </div>
    );
  }
}
export default OrdersTableSectionExpandable;
